/**
 * Company-volume client (DEV-3636, Skynet.Loans behind the loans gateway).
 * GET /api/companyVolume/units returns the bare funded-unit COUNT over a trailing
 * window (max 365 days) for the authenticated user's company.
 *
 * RESPA §8 / Reg Z 1026.36(d): a bare count ONLY — no tier, no dollars, no
 * gap-to-next, no "earn more" framing.
 *
 * Response shape: { fundedUnits, windowDays, asOf }
 */
export class CompanyVolumeApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getFundedUnits({ trailingWindowDays, config = {} } = {}) {
    return this.#http.get('/api/companyVolume/units', {
      ...config,
      params: { trailingWindowDays },
    });
  }
}
